export default {
  controls: [
    {
      title: 'controls.folding_of_siderails',
      icon: 'icon-postranice-sprint',
      animation: 'folding_of_siderails_down',
      autoHideLabel: true,
      visible: true,
      toggle: true
    },
    {
      title: 'controls.push_handles',
      icon: 'icon-handles',
      animation: 'pushhandles_down',
      autoHideLabel: true,
      visible: true,
      toggle: true
    },
    {
      title: 'controls.poles',
      icon: 'icon-poles',
      animation: 'poles',
      autoHideLabel: true,
      visible: true,
      toggle: true
    },
    {
      title: 'controls.idrive',
      icon: 'icon-idrive',
      animation: 'idrive',
      autoHideLabel: true,
      visible: true,
      toggle: true
    },
  ],
  solutions: [
    {
      title: 'Ergonomic Drive that Goes the Distance',
      style: 'video_thumbnails',
      image: 'solution--easy-patient-transportation.jpg',
      explanation: 'easy_patient_transportation'
    },
    {
      title: 'Safety Proven in Million Carebeds',
      style: 'video_thumbnails',
      image: 'solution--fall-prevention.jpg',
      explanation: 'fall_prevention'
    },
    {
      title: 'Empowered Patient Comfort',
      style: 'video_thumbnails',
      image: 'solution--simplify-caregiver-procedures.jpg',
      explanation: 'simplify_caregiver_procedures'
    },
  ],
  keyFeatures: [
    {
      title: 'key_features.transportation',
      style: 'thumbnails',
      image: 'key_features--transportation.png',
      explanation: 'transportation',
    },
    {
      title: 'key_features.safety',
      style: 'thumbnails',
      image: 'key_features--safety.png',
      explanation: 'safety',
    },
    {
      title: 'key_features.efficiency',
      style: 'thumbnails',
      image: 'key_features--efficiency.png',
      explanation: 'efficiency',
    },
    {
      title: 'key_features.positions',
      style: 'thumbnails',
      image: 'key_features--cardiac_chair.png',
      explanation: 'positions',
    }
  ],
  modifications: [
    {
      title: 'modifications.mattress',
      icon: 'icon-mattress',
      options: {
        style: 'thumbnails',
        default: 0,
        items: [
          {
            title: 'modifications.mattress.with_mattress',
            image: 'modifications--with_mattras.png',
            modelParts: [
              {
                name: 'matrace_geoPIV',
                visible: true
              }
            ]
          },
          {
            title: 'modifications.mattress.without_mattress',
            image: 'modifications--without_mattras.png',
            modelParts: [
              {
                name: 'matrace_geoPIV',
                visible: false
              }
            ]
          }
        ]
      }
    },
    {
      title: 'modifications.accessories',
      icon: 'icon-accessories-sprint400',
      explanation: 'accessories',
      options: {
        style: 'thumbnails',
        default: 1,
        items: [
          {
            title: 'modifications.head_support.with',
            image: 'modifications--with_support.png',
            modelParts: [
              {
                name: 'head_support',
                visible: true
              },
              {
                name: 'foot_support',
                visible: true
              }
            ]
          },
          {
            title: 'modifications.head_support.without',
            image: 'modifications--without_support.png',
            modelParts: [
              {
                name: 'head_support',
                visible: false
              },
              {
                name: 'foot_support',
                visible: false
              }
            ]
          }
        ]
      }
    }
  ]
}